export default "__VITE_ASSET__0cab6e93__"